import { IconActionClose } from "@/components/Icons";
import { mcn } from "@/utils/mergeClassNames";
import { Dialog as HeadlessuiDialog } from "@headlessui/react";
import {
  CompetenceGraph,
  GraphSubtopic,
} from "@/components/CompetenceGraph/CompetenceGraph";
import { YourInspiration } from "@/components/CompetenceGraph/YourInspiration";
import React from "react";

type Props = {
  open: boolean;
  onClose: () => void;
  topicName: string;
  graphSubtopics: GraphSubtopic[];
  showYourInspiration?: boolean;
  className?: string;
};

export function CompetenceGraphModal(props: Props) {
  const { onClose, open, topicName, graphSubtopics, showYourInspiration } =
    props;

  return (
    <HeadlessuiDialog
      open={open}
      onClose={onClose}
      className={mcn("relative z-50", props.className)}
    >
      <div className="fixed inset-0 h-full w-full bg-white bg-opacity-30" />
      <div className="fixed inset-0 h-full">
        <div className="flex justify-center items-center min-h-full">
          <div className="p-md max-w-[1000px]">
            <HeadlessuiDialog.Panel
              className={mcn(
                "shadow-elevation-3",
                "rounded-2 p-xl tablet:p-2xl ",
                "relative",
                "bg-blue text-white"
              )}
            >
              <button
                className={mcn(
                  "absolute right-xs top-xs",
                  "hover:text-yellow-100",
                  "focus-visible:default-focus",
                  "rounded-full p-2xs"
                )}
                onClick={props.onClose}
              >
                <IconActionClose fontSize={24} />
              </button>
              <div>
                {showYourInspiration ? (
                  <YourInspiration
                    topicName={topicName}
                    graphSubtopics={graphSubtopics}
                    showMobileFlipScreenTip={false}
                  />
                ) : (
                  <div
                    className={mcn(
                      "flex flex-col gap-y-8 items-center justify-center mt-xl tablet:mt-xl"
                    )}
                  >
                    <h2 className="text-style-headline3 text-light-yellow text-center">
                      {topicName}
                    </h2>
                    <div className="max-mobile:overflow-x-auto">
                      <CompetenceGraph
                        subtopics={graphSubtopics}
                        showMobileFlipScreenTip={false}
                      />
                    </div>
                  </div>
                )}
              </div>
            </HeadlessuiDialog.Panel>
          </div>
        </div>
      </div>
    </HeadlessuiDialog>
  );
}
